import type { RouteConfig } from 'vue-router';
import Home from './Home.vue';

const homeRoutes: RouteConfig[] = [
    {
        path: '',
        name: 'home',
        component: Home,
        meta: {
            navbarTitle: 'Home',
            pageBannerTitle: 'Welcome to Argonaut',
            navbarIcon: 'mdi-home',
            featureFlags: [],
        },
    },
    {
        path: '/sign-in',
        name: 'signIn',
        component: () => import(/* webpackChunkName: "users" */ '../auth/SignIn.vue'),
        meta: {
            featureFlags: [],
        },
    },
];

export default homeRoutes;
